import { Injectable } from "@angular/core";
import { BACKEND_URI } from "../config/config-vars";
import { HttpClient } from "@angular/common/http";
import { GameService } from "./game.service";
import { LoginService } from "./login.service";
import { firstValueFrom, map } from "rxjs";
import { Cabinet } from "../models/cabinet.model";

const BASE_URL = `${BACKEND_URI}/api/cabinet`;
const GET_ALL_URL = BASE_URL;
const INSERT_URL = BASE_URL;
const UPLOAD_FILES_URL = `${BASE_URL}/file/upsert`;
const UPDATE_URL = (id) => `${BASE_URL}/${id}`;
const GET_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DELETE_BY_ID_URL = (id) => `${BASE_URL}/${id}`;
const DOWNLOAD_FILES_URL = `${BASE_URL}/file/download`;



interface FileUploadDetail {
    fileName: string;
    file: ArrayBuffer;
}

@Injectable({providedIn: 'root'})
export class CabinetService {
 

    constructor(private http: HttpClient, private loginService: LoginService){}

    async getAll(): Promise<Cabinet[]> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<Cabinet[]>(GET_ALL_URL)
            );
        }
    }

    async getById(id): Promise<Cabinet> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.get<Cabinet>(GET_BY_ID_URL(id))
            );
        }
    }
    async create(data: Cabinet): Promise<Cabinet> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.post<Cabinet>(INSERT_URL, data)
            );
        }
    }
    async update(id, data: Cabinet): Promise<Cabinet> {
        if(this.loginService.isloggedIn) {
            return await firstValueFrom(
                this.http.put<Cabinet>(UPDATE_URL(id), data)
            );
        }
    }

    async delete(id): Promise<void> {
        if(this.loginService.isloggedIn) {
            await firstValueFrom(
                this.http.delete(DELETE_BY_ID_URL(id))
            );
        }
    }

    async uploadFiles(files: File[]) {
      if(this.loginService.isloggedIn) {
        const formData = new FormData();
        for(const f of files) {
            formData.append('files', f);
        }
        await firstValueFrom(
              this.http.post(UPLOAD_FILES_URL, formData)
        );
      }
    }

    async download(): Promise<FileUploadDetail> {
        if(this.loginService.isloggedIn) {
            console.log("BoardService.download()")
            return await firstValueFrom(
                this.http.get(DOWNLOAD_FILES_URL, {
                    headers: {
                    },
                    observe: "response",
                    responseType: "arraybuffer"
                }).pipe(
                    map(response => {
                        const fileName = response.headers.get("Content-Disposition")
                            ?.split(';')[1].split('=')[1];
                        const file = response.body;
                        return {
                            fileName, file
                        };
                    })
                )
            );
        }
      }
}